import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';

interface Payload {
  layoutType: LayoutType;
  fromTabId: string | null;
  toTabId: string;
}

/**
 * Reassigns all sections belonging to `fromTabId` to `toTabId` without
 * changing their relative order. Used when naming the implicit null tab:
 * the sections on the null tab are moved to the newly created named tab.
 */
export const reassignSectionsToTab = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { layoutType, fromTabId, toTabId } = payload;
  const sections = state[layoutType].sections;
  const tabs = state[layoutType].tabs;

  if (fromTabId === toTabId) return;
  if (!tabs.some((t) => t.id === toTabId)) return;

  for (const section of sections) {
    if ((section.tabId ?? null) === fromTabId) {
      section.tabId = toTabId;
    }
  }
};
